/**
 * Fills the `{name}` placeholders of a catalogue sentence with elements (`<code>`, untrusted text), so a sentence
 * that must carry markup is still one whole message in each language and the word order stays the language's own.
 * A placeholder with no value is left as written.
 */

import { Fragment } from 'react';

export function fillTemplate(template: string, values: Readonly<Record<string, React.ReactNode>>): React.JSX.Element {
  const pieces = template.split(/\{(\w+)\}/);
  return (
    <>
      {pieces.map((piece, index) =>
        // Odd positions are the captured placeholder names.
        index % 2 === 1 && piece in values ? (
          <Fragment key={index}>{values[piece]}</Fragment>
        ) : (
          <Fragment key={index}>{index % 2 === 1 ? `{${piece}}` : piece}</Fragment>
        ),
      )}
    </>
  );
}
